<template>
	<div class="topheader">
		<div class="right">
			<div class="setColors">
				<div class="cor" title="Cor padrão" @click="setCor()"><i class="fas fa-palette"></i></div>
				<div class="cor" v-for="cor in cores" :key="cor.cor" :title="cor.title" @click="setCor(cor.cor)" :class="cor.cor" :style="{background: cor.cor}"></div>
			</div>
		</div>
		<div class="bar"></div>
		<Player/>
	</div>
</template>

<script>
import Player from './player.vue'
import {base} from '../../var.js'
import axios from 'axios';

export default {
	name: 'TopHeader',
	mixins: [Player],
	components:{
		Player
	},
	data() {
		return {
			mydadosShow: true,
			cores: [],
			root: null
		}
	},
	mounted: function() {
		this.root = document.documentElement;
		this.setCor();
		this.getCollor();
		if(localStorage.getItem('color') !== null){
			this.setCor(localStorage.getItem('color'))
		}
	},
	methods: {
		setCor(c){
			if(c == undefined){
				this.root.style.setProperty("--color1", '#45BD62');
			}else{
				this.root.style.setProperty("--color1", c);
				localStorage.setItem('color', c)
			}
		},
		async getCollor(){
			const req = await axios.get(base+"cores");
			this.cores = req.data.cores;
		}
	}
}
</script>

<style scoped>
.topheader {
	position: fixed;
	top: 0;
	left: 0;
	display: flex;
	justify-content: space-around;
	padding: 0 20px;
	width: 100%;
	height: 74px;
	background-color: #fff;
	box-shadow: 0 1px 5px rgba(0,0,0,.1);
	z-index: 2;
}

.setColors {
	float: left;
	position: relative;
	margin: 20px 0 0 0;
}

.setColors .cor {
	width: 26px;
	height: 26px;
	float: left;
	border-radius: 4px;
	text-align: center;
	line-height: 35px;
	color: #fff;
	margin: 5px 0 0 5px;
	box-shadow: 0 1px 5px rgba(0,0,0,.1);
}

.setColors .cor:first-of-type {width: 35px;height: 35px;font-size: 12px;background-color: #45BD62;margin: 0;}

.topheader .bar {
	position: relative;
	width: 1px;
	height: 80%;
	margin-top: 8px;
	background-color: rgba(0,0,0,.15);
}

</style>